/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';

import { SectionTitle } from 'components';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import renderHistorialPasos from '../renderHistorialPasos/renderHistorialPasos';

interface HistorialProps {
  solicitudesPendientes: SolicitudPendiente | undefined;
}

const Historial = ({ solicitudesPendientes }: HistorialProps) => (
  <>
    <SectionTitle text={I18n.t('Historial de pasos')} />
    {renderHistorialPasos({ pasos: solicitudesPendientes?.pasos || [] })}
  </>
);

export default Historial;
